export enum PRODUCT_CARD_ORDER_STEP_TYPE {
  availableBlock = 'availableBlock',
  pendingBlock = 'pendingBlock',
  notAvailableBlock = 'notAvailableBlock'

}
